import { LOCALE } from '../../configs/main'

export default class Conductor {
    handler = null

    constructor(handlersMap) {
        this.handler = handlersMap[LOCALE]
    }
}
